import React from 'react';
import Premier from '@panel/commons/assets/icons/tag-premier.svg';
import ImageDefault from '../../assets/img/imageInmobiliariaDefault.svg';
import { ContentLayout, Img, Label, DescriptionContainer, TagPremier } from './styles';

const PublisherDetail = ({ namePublisher, isPremier, urlLogo }) => {
  return (
    <ContentLayout data-panel='panel-estadisticas-publisher-container'>
      {urlLogo ? (
        <Img src={urlLogo} data-panel='panel-estadisticas-publisher-logo'>
          {isPremier && <TagPremier src={Premier} data-panel='panel-estadisticas-publisher-logoPremier' />}
        </Img>
      ) : (
        <Img src={ImageDefault} data-panel='panel-estadisticas-publisher-defaultLogo'>
          {isPremier && <TagPremier src={Premier} data-panel='panel-estadisticas-publisher-logoPremier' />}
        </Img>
      )}
      <DescriptionContainer>
        <Label data-panel='panel-estadisticas-publisher-name'>{namePublisher}</Label>
      </DescriptionContainer>
    </ContentLayout>
  );
};

export default PublisherDetail;
